import { render, staticRenderFns } from "./HamburgerMenu.vue?vue&type=template&id=efa8a79c&"
import script from "./HamburgerMenu.vue?vue&type=script&lang=ts&"
export * from "./HamburgerMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports